import * as React from 'react';

export const Checkbox: React.FC<{ has?: 'error' | 'success' | 'warning' }> = ({ children, has }) => (
  <div className={has ? `has-${has}` : undefined}>
    <div className="checkbox">
      <label>{children}</label>
    </div>
  </div>
);
